import { Reducer } from '@reduxjs/toolkit'

import { tracker } from '_libs/common/tracker'
import { serverSide } from '@marketplace-web/shared/environment'
import { coreReducers, staticReducers } from 'state/reducers'
import { configureStore, createReducers } from 'state/store'

type Reducers = typeof staticReducers & typeof coreReducers
type InitialState = {
  [K in keyof Reducers]: Reducers[K] extends Reducer<infer S> ? Partial<S> : never
}

export const configureNextAppRouterStore = (initialState: Partial<InitialState>) => {
  const nextReducers = { ...coreReducers }
  const reducer = createReducers(nextReducers)

  const { store } = configureStore(initialState, reducer)

  // TODO: remove after `session_cookie_in_response` and `next_auth_refresh_token_interceptor` FS are scaled
  if (!serverSide) tracker.initialize(store)

  return store
}
